export default __webpack_public_path__ + "static/media/FaceBook.733e56cc.svg";